import React from "react";
import AppRoutes from "./components/AppRoutes";
import './App.css';

const App = () => {
  return (
    <React.Fragment>
      <AppRoutes />
    </React.Fragment>
  );
}

export default App;
